<template>
<div class="container login">
  <h1 class="text-center login-title">KICHITTO</h1>
  <error-list :errors="errors.nonFieldErrors" />
  <div class="account-wall">
    <el-form class="form-signin">
      <el-form-item>
        <el-input
          v-model="form.username"
          @keyup.enter.native="submit"
          placeholder="ユーザ名" />
        <error-list :errors="errors.username" />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.password"
          type="password"
          @keyup.enter.native="submit"
          placeholder="パスワード" />
        <error-list :errors="errors.password" />
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="saveToken" type="checkbox" value="remember-me">ログイン状態を保存</el-checkbox>
      </el-form-item>
      <el-button type="primary" @click.prevent="submit">ログイン</el-button>
    </el-form>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'

import ErrorList from '@/parts/ErrorList'
// import moment from 'moment'
// import ShopType from 'ShopType'
// import Cookies from 'js.cookie'

export default {
  name: 'Login',
  data () {
    return {
      form: {
        username: null,
        password: null,
      },
      saveToken: true,
      errors: {
        username: [],
        password: [],
        nonFieldErrors: [],
      },
      errorResponse: null,
      formLabels: {
        username: 'ユーザ名',
        password: 'パスワード',
      },
    }
  },
  computed: {
    nonFieldErrors () {
      if (this.errorResponse && this.errorResponse.body.nonFieldErrors) {
        return this.errorResponse.body.nonFieldErrors
      } else {
        return []
      }
    },
    fieldErrors () {
      let errors = {}
      let e = this.errorResponse ? this.errorResponse.body : {}

      Object.assign(errors, {
        username: e.username ? e.username : [],
        password: e.password ? e.password : [],
      })

      return errors
    },
  },
  methods: {
    ...mapActions(['login']),
    submit () {
      this.errorResponse = null
      this.login([this.form.username, this.form.password, this.saveToken]).then(res => {
        this.$router.push({name: 'Index'})
      }, err => {
        this.$err400(err)
      })
    },
  },
  components: {
    ErrorList,
  },
}
</script>

<style scoped>
.login {
  width: 360px;
  margin: auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/Login.vue